import React,{useEffect,useState, useRef } from 'react';
import Axios from '../../lib/axios/axiosInstance';
import { Container, Row, Col, Tab, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as AuthVerify from '../../lib/common';
import {BASE_URL} from '../../lib/constant';
import { Flip, Slide, toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { Formik } from "formik";
import * as Yup from "yup";
import InputField from "../InputField/InputField";
import "./CostCenter.styles.css";

const CostCenter = () => {

    const [logedIn, setLogedIn] = useState(false);
    const [userDetails, setUserDetails] = useState(false);
    const [costCenters, setCostCenters] = useState(false);
    
    const [selectedCostCenter, setSelectedCostCenter] = useState(false);
    const [dmShow, setDmShow] = useState(false);
    const [emShow, setEmShow] = useState(false);

    async function getCostCenter () {
        // userDetails.arnum="ARM-90195171";
        await Axios.get(`/corporate/costcenter/${userDetails.arnum}`)
        .then(async (costcenters) => {
            if (costcenters.status == 200 && costcenters.data?.data?.costcenters) {
              setCostCenters(costcenters.data.data.costcenters);
            }
        })
    }

    async function addNewCostCenter (values) {
      await Axios.post(`/corporate/costcenter/${userDetails.arnum}`,{
        "costcenter": {
          "ccname": values.ccname
        }
      })
      .then(async (catalogs) => {
        getCostCenter(userDetails.refnum);
        toast.success('New cost center added successfully', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
        });
        setEmShow(false);
      })
  }

  async function deleteCostCenter () {
    // https://devb2b.bizpoint-intl.com:3082/api/corporate/costcenter/:arnum/:ccnum
    if(costCenters.length==1)setCostCenters(false)
    if(selectedCostCenter){
      await Axios.delete(`/corporate/costcenter/${userDetails.arnum}/${selectedCostCenter}`)
      .then(async (catalogs) => {
        getCostCenter(userDetails.refnum);
        toast.success('Cost center deleted successfully', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
            transition: Slide,
        });
        setDmShow(false);
      })
    }
  }

    useEffect(() => {
        setLogedIn(AuthVerify.isUserLogedIn());
    }, []);

    useEffect(() => {
        if(logedIn)setUserDetails(AuthVerify.getUser());
    }, [logedIn]);

    useEffect(() => {
        if(userDetails)getCostCenter(userDetails.refnum);
    }, [userDetails]);

  return (
    <div className="col-main">
      <div className="my-account">
        <div className="page-title">
          <h2 style={{ paddingTop: "12px" }}>Cost Center</h2>
          {/* <p>Loremn osum doky sit conseete,tut ugiscirq elit. Maecenas quis ex elei'end enim eget. eleifeod gwus. Oonec quis condenentum fin bus
                  </p> */}
        </div>
        <hr/>
        <div className="dashboard">
          <div className="box-account" style={{ display: "grid" }}>
          <div className="toolbar">
              <div className="row">
                <div className="col-md-3 col-sm-3" style={{display: "flex"}}>
                  <h2 style={{fontSize: "16px" , letterSpacing: "1px", marginTop: "0",textTransform: "uppercase", marginBottom: "auto", fontWeight: "700"}}>Your Cost Center</h2>
                  
                </div>
                {AuthVerify.getPermissions("CostCenter")?.addnew &&
                <div className="col-sm-3 text-right" style={{float:"right"}}>
                  <a href="#" onClick={()=>setEmShow(true)}>+ Add New Cost Center</a>
                </div>}
              </div>
            </div>
          </div>
          <div className="box-account" style={{ display: "grid" }}>
            <div className="header-nav-dropdown-wrapper">
              { costCenters ? costCenters.map((item,i) => {
                var style = {
                  width: "20%"
                };
                if(item.active){
                  style.border="3px #5aa0dd solid";
                }
                return (<div
                  className="jtv-custom-box"
                  style={style}
                  key={i}
                >
                  <i className="fa fa-archive"></i>
                  <h5 className="heading" style={{ marginBottom: "0" }}>
                    {item.ccname}
                  </h5>
                  {/* <small style={{ color: "#3c763d" }}>Active</small> */}
                  <small style={{marginTop:"15px"}}>
                  {AuthVerify.getPermissions("CostCenter")?.view && <Link to={`/costcenter-details?ccnum=${encodeURIComponent(item.ccnum)}`}>View</Link>} {" "}
                  {AuthVerify.getPermissions("CostCenter")?.edit && <Link to={`/costcenter-details?ccnum=${encodeURIComponent(item.ccnum)}`}>Edit</Link>} {" "}
                  {AuthVerify.getPermissions("CostCenter")?.delete && <Link to="#" onClick={()=>{setSelectedCostCenter(item.ccnum); setDmShow(true);}} style={{color:"red"}}>Delete</Link>}<br/>
                  </small>
                  <p></p>
                </div>)
              }):
              <Col sm={12} style={{textAlign:"center"}}>No Catalog Found !</Col>
              }
            </div>
          </div>
          <br />
        </div>
      </div>

      
      <Modal show={dmShow} dialogClassName="modal-90w" animation={false} fade={false} style={{opacity:1}} onHide={()=>setDmShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Delete Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure about the delete ?
        </Modal.Body>
        <Modal.Footer>
        <button
              className="button btn-primary"
              title="Proceed to Checkout"
              type="button"
              onClick={()=>deleteCostCenter()}
              style={{
                marginRight: "10px",
                padding: "10px"
              }}
              >
            <span>Confirm</span>
          </button>
          <button
            className="button btn-danger"
            title="Proceed to Checkout"
            type="button"
            onClick={()=>setDmShow(false)}
            style={{
              marginRight: "10px",
              padding: "10px"
            }}
          >
            <span>Close</span>
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={emShow} dialogClassName="modal-90w" animation={false} fade={false} style={{opacity:1}} onHide={()=>setEmShow(false)}>
        <Modal.Header closeButton={false}>
          <Modal.Title>Create New Cost Center</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Formik
          initialValues={{ccname:''}}
          validationSchema={Yup.object().shape({
            ccname: Yup.string().min(2).required("Cost Center name is required"),
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            setSubmitting(false);
            addNewCostCenter(values);
          }}
          enableReinitialize
        >
          {(props) => {
            const {
              values,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              errors, touched
            } = props;
            return (
              <Form onSubmit={handleSubmit}>
                <div className="box-border">
                  <div className="form-list">
                      
                      <Row>
                        <Col xl={12} sm={12}>
                          <Row>
                            <Col xl={12} sm={12}>
                              <InputField
                                Name="ccname"
                                id="ccname"
                                Labels="Cost Center Name"
                                Type="text"
                                value={values.ccname}
                                onChange={e=>{handleChange(e);}}
                                className={(errors.ccname && touched.ccname) ? 'is-invalid' : 'form-control'}
                              />
                            </Col>
                            {/* <Col xl={6} sm={6}>
                                <InputField
                                  Name="addr2"
                                  id="addr2"
                                  Labels="Address 2"
                                  Type="text"
                                  value={values.addr2}
                                  onChange={handleChange}
                                  isInvalid={!!errors.addr2}
                                  className={(errors.addr2 && touched.addr2) ? 'is-invalid' : 'form-control'}
                                />
                              </Col> */}
                          </Row>
                        </Col>
                        
                      </Row>
                  </div>
                </div>
                <Row>
                <div className="cart_navigation">
                  <button
                    className="button btn-proceed-checkout btn-danger"
                    title="Proceed to Checkout"
                    type="button"
                    onClick={() => setEmShow(false)}
                    style={{
                      marginRight: "10px",
                      padding: "10px"
                    }}
                  >
                    <span>Close</span>
                  </button>

              
                    <button
                      className="button btn-proceed-checkout"
                      title="Proceed to Checkout"
                      type="submit"
                      style={{
                        marginRight: "10px",
                        background: "#337ab7",
                        border: "0px solid #337ab7",
                        padding: "10px"
                      }}
                    >
                      <span>Create</span>
                    </button>
                </div>
                
                </Row>
              </Form>
            );
          }}
        </Formik>
        </Modal.Body>
      </Modal>

    </div>
  );
};

export default CostCenter;
